import styled from 'styled-components/macro';

export const FABMobile = styled.div<{ bottom?: string }>`
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    display: block;
    position: fixed;
    bottom: ${({ bottom }) => bottom || '1rem'};
    right: 1rem;
    z-index: ${({ theme }) => theme.zIndex.zIndex3};

    & svg path {
      stroke: ${({ theme }) => theme.colors.white};
    }
  }
`;
